import SingleSelectType from "../view-models/SingleSelectType";

export const businessUnits = {
  NA: { name: "N/A", i18n: "na", id: 0 },
  QET: { name: "QET", i18n: "qet", id: 1 },
  ACT: { name: "ACT", i18n: "act", id: 2 },
  HPS: { name: "HPS", i18n: "hps", id: 3 }
};

export function getBusinessUnitByUserUnit(userBusinessUnit: number) {
  const unit = Object.values(businessUnits).find(
    unit => unit.id === userBusinessUnit
  );
  if (unit) {
    return new SingleSelectType({
      key: unit.id,
      name: unit.name
    });
  }
  return null;
}
